module.exports = __webpack_public_path__ + "static/img/THOMAS-McGUANE.fc8b8ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/THOMAS-McGUANE.jpg
// module id = XjvV
// module chunks = 0